module.exports = __webpack_public_path__ + "static/media/cv_27_07_2020.8f926d58.pdf";